export default __webpack_public_path__ + "static/media/ServicesBg1.cc679aa7.png";